import { c as _c } from "react/compiler-runtime";
import type { PropsWithStyles } from '@morpho-org/ui-v6/types';
import { cn } from '@morpho-org/ui-v6/utils';
import { memo, Suspense } from 'react';
import { NavSegmentControl } from '@/components/common/NavSegmentControl';
import WalletButton from '@/components/common/WalletDropdown/WalletButton';
import { WrongNetworkButton } from '@/components/common/WrongNetworkButton/WrongNetworkButton';
import { useIsMdUp } from '@/hooks/useBreakpoints';
import { useNavigationOptions } from '@/hooks/useNavigationOptions';
import { useTrackPortfolioNavTabViewed } from '@/lib/analytics/client/hooks/useTrackPortfolioNavTabViewed';
import MenuButton from '../MenuDropdown/MenuButton/MenuButton';
export type NavBarProps = PropsWithStyles;
const NavBar = t0 => {
  const $ = _c(15);
  const {
    className
  } = t0;
  const {
    navigationValue,
    navigationOptions,
    onNavigationValueChange
  } = useNavigationOptions();
  const isMdUp = useIsMdUp();
  useTrackPortfolioNavTabViewed(isMdUp);
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col", cn("h-full", className));
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MenuButton variant="secondary" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onNavigationValueChange) {
    t3 = value => onNavigationValueChange(value as string);
    $[3] = onNavigationValueChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== navigationOptions || $[6] !== navigationValue || $[7] !== t3) {
    t4 = <div className="flex items-center gap-[28px]">{t2}<NavSegmentControl className="rounded-lg bg-transparent p-[3px] [&_button]:rounded-lg" size="medium" id="navbar-segment-control" options={navigationOptions} onChange={t3} value={navigationValue} noPadding={true} /></div>;
    $[5] = navigationOptions;
    $[6] = navigationValue;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="gap-xs flex items-center"><Suspense><WrongNetworkButton /><WalletButton /></Suspense></div>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <div className="py-sm flex justify-between px-[24px]">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = <div className={t1}>{t6}</div>;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default memo(NavBar);